import { lazy, Suspense } from "react"
import { Helmet } from "react-helmet-async"
import Header from "@/components/Header"
import Hero from "@/components/Hero"
import Footer from "@/components/Footer"
import { OrganizationSchema, FAQSchema } from "@/components/SchemaOrg"

const Features = lazy(() => import("@/components/Features"))
const ShopifyProductGrid = lazy(() => import("@/components/ShopifyProductGrid"))
const SkillsSection = lazy(() => import("@/components/SkillsSection"))
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"))
const FAQ = lazy(() => import("@/components/FAQ"))
const NewsletterCTA = lazy(() => import("@/components/NewsletterCTA"))

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <link rel="canonical" href="https://mmqueen-magnetics.com/" />
        <meta
          name="description"
          content="Magnetne ploščice s potiskanimi motivi za otroke. Kompleti ali posamezni kosi. CE certifikat, EN71 testirano. Brezplačna dostava nad 45 €."
        />
      </Helmet>
      <OrganizationSchema />
      <FAQSchema />
      <Header />
      <main>
        <Hero />
        <div className="flex flex-col">
          <div className="order-1 md:order-2 reserve-grid">
            <Suspense fallback={null}>
                <ShopifyProductGrid
                  showSupercategoryToggle={false}
                  shopifyQuery="tag:kompleti"
                  headerBadge="Pripravljeni kompleti"
                  headerTitle="Kompleti za vsak okus"
                  headerDescription="Vse kar potrebuješ v enem kompletu."
                  viewAllLink="/trgovina?tab=kompleti"
                  viewAllLabel="Poglej vse komplete"
                  sectionClassName="bg-card-md-gradient py-12 md:py-16"
                  centerGrid
                  limit={4}
                  desktopLimit={3}
                />
              </Suspense>
          </div>

          <div className="order-2 md:order-1 reserve-features">
            <Suspense fallback={null}>
                <Features />
              </Suspense>
          </div>
        </div>

        <div className="reserve-grid">
            <Suspense fallback={null}>
              <ShopifyProductGrid
                showSupercategoryToggle={false}
                fixedSupercategory="posamezne ploščice"
                headerDescription="Sestavi svoj komplet po meri."
                sectionClassName="gradient-md-bg-card py-12 md:py-16"
                mobileLimit={4}
              />
            </Suspense>
        </div>

        <div className="reserve-skills">
            <Suspense fallback={null}>
              <SkillsSection />
            </Suspense>
        </div>

        <div className="reserve-testimonials">
            <Suspense fallback={null}>
              <TestimonialsSection />
            </Suspense>
        </div>

        <div className="reserve-faq">
            <Suspense fallback={null}>
              <FAQ
                title="Pogosta vprašanja"
                subtitle="Varnost, dostava, materiali in vse ostalo."
                limit={4}
                showLink={true}
                showCategories={false}
              />
            </Suspense>
        </div>

        <div className="reserve-newsletter">
            <Suspense fallback={null}>
              <NewsletterCTA />
            </Suspense>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Index
